module.exports = __webpack_public_path__ + "static/media/small-banner.dbbc96f0.jpeg";